export default __webpack_public_path__ + "static/media/worstpain.8fec79a2.svg";